import branchesViewTemplate from "./BranchesViewTemplate";

var viewerStates = function ($stateProvider, $urlRouterProvider) {

  $urlRouterProvider.otherwise("/branches");

  $stateProvider

    .state('branchesView', {
      url: '/branches/:branch',
      controller: 'BranchesViewController',
      template: branchesViewTemplate,
      controllerAs: 'branchesCtrl',
      params: {
        branch: { value: null, squash: true },
      }
    });

};

viewerStates.$inject = ['$stateProvider', '$urlRouterProvider'];
export default viewerStates;
